/**
 * Garden Paper on the site's own chrome (Experience.chrome): cream type and a
 * marigold Give over the sage hero, the footer on the hero's deepest sage
 * with a marigold rule. Its own file so the registry can read it without
 * loading the page.
 */
export const CHROME = {
  header: { accent: '#d99e3c', ink: '#f3ecdc', onAccent: '#222819' },
  footer: { background: '#222819', rule: '#d99e3c' },
};
